namespace advisorop.components.advisor {
    
    export class RiskMonitorController{
        user: domains.identity.IUser;
        allocationPlans: domains.ISecurityAllocationPlan[] = [];
        advisoryFirms: Array<domains.IAdvisoryFirm> = [];
        selAdvisoryFirm: domains.IAdvisoryFirm;
        selAllocationPlan: domains.ISecurityAllocationPlan;

        static $inject = ["advisorService", "advisoryFirmApi", "generalService"]
        constructor(private advisorService: services.AdvisorService,
            private advisoryFirmApi: services.AdvisoryFirmApi,
            private generalService: services.GeneralService) {
        }

        loadAllocationPlans(): void {
            if (this.selAdvisoryFirm) {
                this.advisorService.getSecurityAllocationPlans(this.selAdvisoryFirm.id)
                    .then(response => {
                        this.allocationPlans = response.data;
                         //console.log("Allocation plans", this.allocationPlans);
                         if (this.selAdvisoryFirm.defaultAllocationPlanId && this.selAdvisoryFirm.defaultAllocationPlanId > 0) {
                             this.selAllocationPlan = this.allocationPlans.filter(f => f.id == this.selAdvisoryFirm.defaultAllocationPlanId)[0];
                         } else {
                             this.selAllocationPlan = this.allocationPlans.filter(f => f.allocationPlanType === 0)[0];
                        }
                    },
                    err => toastr.error("Error when trying to load allocation plans. ERROR " + err.status + " " + err.data));
            } else {
                this.allocationPlans = [];
            }
        };

        loadAdvisoryFirms(): void {
            this.advisoryFirmApi.getAdvisoryFirms()
                .then(response => this.advisoryFirms = response.data,
                err => toastr.error("Error occured when loading advisory firms. ERROR " + err.status + " " + err.data));
        };

        runRiskMonitor(): void {
            if (this.selAdvisoryFirm && this.selAllocationPlan) {
                this.advisorService.startRiskMonitor(this.selAdvisoryFirm.id, this.selAllocationPlan.id)
                    .then(response => toastr.info("Risk monitor is done!"),
                          err => toastr.warning("Risk monitor failed to complete! ERROR " + err.status + " " + err.data));
            }
        };

        runRiskMonitorForAllMyFirms(): void {
            this.advisorService.startRiskMonitorForAllFirms()
                .then(data => toastr.success("Risk monitor has been executed for all of your firms"),
                err => this.generalService.showError(err));
        }

        $onInit(): void {
        }

        $onChanges(evt): void {
            for (var key in evt) {
            }
        }
    }
    
    class RiskMonitor implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        
        constructor() {
            this.bindings = {
            };
            this.controller = RiskMonitorController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/advisor-module/components/risk-monitor.html';
        }
    }
    angular.module(Constants.APP).component("riskMonitor", new RiskMonitor());

}